export default {
  logoutInactiveUser: 'logoutInactiveUser'
}
